import { render, staticRenderFns } from "./AttributeBatchInput.vue?vue&type=template&id=24904ab0&scoped=true"
import script from "./AttributeBatchInput.vue?vue&type=script&lang=js"
export * from "./AttributeBatchInput.vue?vue&type=script&lang=js"
import style0 from "./AttributeBatchInput.vue?vue&type=style&index=0&id=24904ab0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24904ab0",
  null
  
)

export default component.exports